import React from 'react';
import {
  Card,
  CardContent,
  Box,
  Typography,
  Button,
} from '@mui/material';
import { Visibility, FileDownload } from '@mui/icons-material';

interface DocumentCardProps {
  title: string;
  icon: React.ReactNode;
  filename: string;
  onPreview: (filename: string, type: 'image' | 'pdf') => void;
  onDownload: (filename: string, displayName: string) => void;
  displayName: string;
  fileType?: 'image' | 'pdf';
}

export default function DocumentCard({
  title,
  icon,
  filename,
  onPreview,
  onDownload,
  displayName,
  fileType = 'image',
}: DocumentCardProps) {
  return (
    <Card sx={{ height: '100%' }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          {icon}
          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
            {title}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button
            size="small"
            startIcon={<Visibility />}
            onClick={() => onPreview(filename, fileType)}
          >
            Visualizar
          </Button>
          <Button
            size="small"
            startIcon={<FileDownload />}
            onClick={() => onDownload(filename, displayName)}
          >
            Download
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
} 